import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Tooltip } from './common';
import SvgIcon from './SvgIcon';

function TableAccessaryLabel(props) {
  const { icon, title, tooltip, ...restProps } = props;

  const iconProps = {
    width: 16,
    height: 16
  };

  return (
    <Box
      style={{ cursor: 'pointer' }}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      {...restProps}
    >
      <Box flex={1} display="flex" justifyContent="center" alignItems="center">
        {!tooltip ? (
          <SvgIcon name={icon} {...iconProps} />
        ) : (
          <Tooltip
            animation="scale"
            delay={[300, 0]}
            duration={300}
            content={tooltip}
            theme="light-border"
            placement="bottom"
          >
            <span>
              <SvgIcon name={icon} {...iconProps} />
            </span>
          </Tooltip>
        )}
      </Box>
      {title && <Text fontSize={'12px'}>{title}</Text>}
    </Box>
  );
}

TableAccessaryLabel.propTypes = {
  icon: PropTypes.string,
  tooltip: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.string
};

TableAccessaryLabel.defaultProps = {
  bg: 'lighterGrayTint',
  pr: 3,
  borderRadius: 4
};

export default TableAccessaryLabel;
